/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function MinimizeIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="minimize"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M20.5 3.5L14 10M14 10L14 5.404M14 10L18.596 10" data-tinysvg-shape="arrow" data-tinysvg-arrow="20.5 3.5 14 10 50" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.5 20.5L10 14M10 14L10 18.596M10 14L5.404 14" data-tinysvg-shape="arrow" data-tinysvg-arrow="3.5 20.5 10 14 50" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
